<template>
  <div>
    <h2>Static Blog Test Page</h2>
    <client-only>
      <ContentDoc path="/blog/git/keeping-your-git-repository-clean-and-efficient">
        <template #default="slotProps">
          <pre style="background:#eee; color:#333; padding:10px; font-size:12px; max-width:100vw; overflow:auto;">
            slotProps: {{ slotProps }}
            slotProps.doc: {{ slotProps?.doc }}
          </pre>
          <div v-if="slotProps && slotProps.doc">
            <ContentRenderer :value="slotProps.doc" />
          </div>
          <div v-else>
            <p>Not found.</p>
          </div>
        </template>
      </ContentDoc>
    </client-only>
  </div>
</template>

<script setup>
// Static ContentDoc test under /pages/blog
</script>
